import { render } from "./CustomerServiceDrawer.vue?vue&type=template&id=b18627da&scoped=true"
import script from "./CustomerServiceDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerServiceDrawer.vue?vue&type=script&lang=js"

import "./CustomerServiceDrawer.vue?vue&type=style&index=0&id=b18627da&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18627da"]])

export default __exports__